import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Currently working for Rakuya Inc. as a Vice President in Product Division, and also one of the DDD Taiwan Community Organizers.
Michael has been in a matrix organization for a long time and played multiple roles to promote the agile and digital transformation of the whole organization.
For the management and operation, Serving as People Manager and Technical Leader.
For the product design and development, Serving as Agile Coach, Product Coach, and Data Science Architect.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      